import { BASE_URL_VCLAIM, DISABLED_BUTTON_SUBMIT, instance1, V1 } from "App/constants";
import { isNull, today } from "App/utils/helpers";
import moment from "moment";
import { useState } from "react";

const defaultButtonSearch = {
  label: "CARI",
  color: "green",
  state: false,
};

export const RESET_STATE_SUPLESI = {
  no_kartu_peserta: "",
  tgl_pelayanan: today(),
};

export const headCellsSuplesi = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "center",
  },
  {
    id: "noRegister",
    disablePadding: true,
    label: "NO REGISTRASI",
    sort: false,
    align: "left",
    minWidth: "150px",
  },

  {
    id: "noSep",
    disablePadding: true,
    label: "NO SEP",
    sort: false,
    align: "left",
    minWidth: "100px",
  },
  {
    id: "noSepAwal",
    disablePadding: true,
    label: "NO SEP AWAL",
    sort: false,
    align: "left",
    minWidth: "100px",
  },
  {
    id: "noSuratJaminan",
    disablePadding: true,
    label: "NO SURAT JAMINAN",
    sort: false,
    align: "left",
    minWidth: "150px",
  },
  {
    id: "tglKejadian",
    disablePadding: true,
    label: "TANGGAL KEJADIAN",
    sort: false,
    align: "left",
    minWidth: "150px",
  },
  {
    id: "tglSep",
    disablePadding: true,
    label: "TANGGAL SEP",
    sort: false,
    align: "left",
    minWidth: "150px",
  },
  
];

export const getHistoryPelayananPesertaSuplesi = async (formData) => {
  try {
    const api = await instance1.post(
      `/bridging`,
      {
        no_kartu_peserta: formData.no_kartu_peserta,
        tgl_pelayanan: formData.tgl_pelayanan,
      },
      {
        headers: {
          method: "post",
          url: `${BASE_URL_VCLAIM}/${V1}/emr/bridging/sep/suplesi-jasa-raharja`,
        },
      }
    );

    const response = api.data.body;
    if (parseInt(response.metaData.code) === 200) {
      return {
        state: true,
        data: isNull(response.response.jaminan) ? [] : response.response.jaminan,
      };
    } else {
      return {
        state: false,
        data: [],
        message: response.metaData.message,
      };
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.body?.metaData?.message,
    };
  }
};

export const useSearchHistorySepSuplesi = (noBpjs) => {
  const [disabled, setDisabled] = useState(defaultButtonSearch);
  const [rows, setRows] = useState([]);
  const [filter, setFilter] = useState({
    tgl_pelayanan: today(),
    no_kartu_peserta: noBpjs,
  });

  const handleChange = (text) => (e) => {
    setFilter({
      ...filter,
      [text]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisabled(DISABLED_BUTTON_SUBMIT);
    if (!isNull(filter.no_kartu_peserta) && !isNull(filter.tgl_pelayanan)) {
      await setNewData();
      setDisabled(defaultButtonSearch);
    }
  };

  const setNewData = async () => {
    try{
      const response = await getHistoryPelayananPesertaSuplesi({
        no_kartu_peserta: filter.no_kartu_peserta,
        tgl_pelayanan: moment(filter.tgl_pelayanan).format('YYYY-MM-DD'),
      });

      if (response.state) {
        setRows(response.data);
      } else {
        setRows([]);
      }
    }catch(err){
      console.log("Err", err)
    }

  };

  return {
    disabled,
    rows,
    handleChange,
    handleSubmit,
    filter,
    setNewData,
  };
};